'use strict';

/**
 * View for rendering the list item of photobox albums
 *
 * @category   View
 * @module     collection.album
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/list-item-photobox.hbs');

require('jquery-sly');

var ListItemPhotoboxView = ColidoItemView.extend({
    template: template,

    wrapItem: false,

    ui: {
        'buttonDelete': '.btn[data-action="delete"]',
    },

    events: {
        'click': 'albumSelected',
        'click @ui.buttonDelete': 'onActionDeleteAlbum',
    },

    modelEvents: {
        'change sync': 'render',
    },

    slider: null,

    /**
     * Callback for redering process
     * @return {void}
     */
    onRender: function() {
        ColidoItemView.prototype.onRender.apply(this, arguments);
        if (this.model.get('images').length > 4) {
            window.setTimeout(function() {
                this.slider = this.$('.sly-frame').sly({
                    horizontal: 1,
                    itemNav: 'basic',
                    speed: 300,
                    mouseDragging: 1,
                    touchDragging: 1,
                    elasticBounds: 1,
                    releaseSwing: 1,
                    dynamicHandle: 1,
                    dragHandle: 1,
                });
            }.bind(this), 50);
        }
    },

    onResize: function() {
        if (this.model.get('images').length > 4) {
            this.slider.sly('reload');
        }
    },

    /**
     * Destroy plugins and additional listener
     */
    onBeforeDestroy: function() {
        if (this.model.get('images').length > 4) {
            this.slider && this.slider.sly && this.slider.sly('destroy');
        }
    },

    /**
     * Is triggered, when the album should be deleted
     * @param {object} event The click event
     */
    onActionDeleteAlbum: function(event) {
        event.stopPropagation();

        Messenger().info({
            message: App.t('collection::album:response:deleted', {name: this.model.get('title')}),
        });

        var imageIds = _.pluck(this.model.get('images'), 'id');
        if (imageIds.length) {
            var action = App.getApiUrl('/assets') + '/' + imageIds.join(',');
            $.ajax(action, {
                type: 'DELETE',
            });
        }

        this.model.destroy();
    },

    /**
     * IS triggered, when an album has been selected
     * @param {object} event The click event
     */
    albumSelected: function(event) {
        this.triggerMethod('album:selected', this.model.get('images'));
    },
});

module.exports = ListItemPhotoboxView;